import React, { useEffect, useRef, useState } from "react";
import Header from "../component/Header";
import Footer from "../component/Footer";
import { Helmet } from "react-helmet";

const API_PDF_URL = process.env.REACT_APP_API_PDF_URL;
const BASE_URL = process.env.REACT_APP_BASE_URL;


const NoticeOtherIntimation = () => {
  const pageid = 17; // <-- static pageid
  const [sections, setSections] = useState([]);
  const [loading, setLoading] = useState(true);
  const sectionRefs = useRef({});

  // Fetch notice & other intimation data
  useEffect(() => {
    const fetchNotices = async () => {
      try {
        const response = await fetch(`${BASE_URL}?pageid=${pageid}`);
        if (!response.ok) throw new Error(`HTTP error! ${response.status}`);
        const result = await response.json();

        if (!result.success || !Array.isArray(result.data)) {
          setSections([]);
          setLoading(false);
          return;
        }

        // Group items by title (e.g., "Notices", "Other Intimations")
        const grouped = {};
        result.data.forEach((item) => {
          const sectionTitle = item.title_name || "Others"; // Section grouping
          if (!grouped[sectionTitle]) grouped[sectionTitle] = [];
          grouped[sectionTitle].push({
            label: item.pdf_name,
            file: item.upload_file_path,
            title: item.title || "", // Individual PDF title
          });
        });

        // Convert grouped object to array
        const finalData = Object.keys(grouped).map((title) => ({
          title,
          items: grouped[title],
        }));

        setSections(finalData);
      } catch (error) {
        console.error("Fetch failed:", error);
        setSections([]);
      } finally {
        setLoading(false);
      }
    };

    fetchNotices();
  }, []);

  // Scroll to first section
  useEffect(() => {
    if (sections.length > 0) {
      const el = sectionRefs.current[sections[0].title];
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }
  }, [sections]);

  return (
    <>
      <Helmet>
        <title>Notice & Other Intimation | Nandan Denim Ltd.</title>
      </Helmet>
      <Header />

      {/* Hero Section */}
      <div className="relative w-full">
        <img
          src="./imgs/investors/investornoticeintimation.png"
          alt="Chiripal Group Banner"
          className="object-cover w-full h-full md:h-[70vh] lg:h-[80vh] xl:h-[88vh]"
        />
        <div className="absolute inset-0 bg-black bg-opacity-30 flex items-center">
          <div className="px-4 sm:px-8 md:px-16 lg:px-32">
            <h1 className="text-yellow-400 text-3xl sm:text-5xl md:text-7xl font-montserrat font-bold text-left">
              Notice & Other Intimations
            </h1>
          </div>
        </div>
      </div>

      {/* PDF Sections */}
      <div className="py-12 px-4 font-signika max-w-7xl mx-auto">
        {loading ? (
          <p>Loading notices and intimations...</p>
        ) : sections.length === 0 ? (
          <p>No notices or intimations found.</p>
        ) : (
          sections.map((section, index) => (
            <div
              key={index}
              ref={(el) => (sectionRefs.current[section.title] = el)}
              className="mb-12"
            >
              <h2 className="text-xl font-extrabold text-[#0b3a6a] mb-4">
                {section.title}
              </h2>
              <ul className="list-disc pl-6 space-y-2 text-[#0b3a6a]">
                {section.items.map(
                  (item, idx) =>
                    item.file && (
                      <li key={idx}>
                        <a
                          href={`${API_PDF_URL}/${item.file}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="hover:underline"
                        >
                          {item.label} {item.title ? `- ${item.title}` : ""}
                        </a>
                      </li>
                    )
                )}
              </ul>
              {index < sections.length - 1 && (
                <hr className="mt-6 border-gray-300" />
              )}
            </div>
          ))
        )}
      </div>

      <Footer />
    </>
  );
};

export default NoticeOtherIntimation;
